<!--
 * @Description: 
--> 
<!--
 * @Description: 账号注册
--> 
<template>
  <div class="register">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      v-show="$comm.titleShow()"
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-form @submit="onSubmit">
      <van-field
        required
        v-model="username"
        label="用户姓名"
        placeholder="请输入用户姓名"
        :rules="[{ required: true, message: '请输入用户姓名' }]"
      >
      </van-field>
      <van-field
        required
        v-model="phone"
        label="手机号码"
        placeholder="请输入手机号码"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
      >
      </van-field>
      <van-field
        required
        v-model="smscode"
        label="验证码"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '请输入验证码' }]"
      >
        <template #button>
          <sms-btn :phone="phone"></sms-btn>
        </template>
      </van-field>
      <div style="margin:0 16px;margin-top:20px;">
        <van-button
          type="info"
          color="#1677FF"
          size="large"
          native-type="submit"
          class="submit-btn"
          >
          立即修改
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'
export default {
  name: 'Home',
  components: {
    smsBtn
  },
  data() {
    return {
      username: '',
      pwd:'',
      confirmPwd: '',
      phone: '',
      smscode: '',
      checked: false,
    }
  },
  mounted() {
  },
  methods: {
    onSubmit() {
      this.$loading('提交中...')
      this.$http.post(this.$api.modifyRegisterInfo, {
        mobile: this.phone,
        uname: this.username,
        smscode: this.smscode
      }).then(res => {
        this.$clear()
        if (res.code==='000') {
          localStorage.setItem('nickname',this.username)
          localStorage.setItem('mobile',this.phone)
          this.$toast('修改成功')
          this.$comm.onClickLeft()
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.register{
  .get-code{
    width:80px;
    height:30px;
    background:rgba(255,255,255,1);
    border-radius:3px;
    border:1px solid rgba(37,138,55,1);
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(37,138,55,1);
  }
}
</style>